'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNewElementOffset = undefined;

var _lodash = require('lodash');

var _dragAndDropUtils = require('../../../utils/dnd/dragAndDropUtils');

var _point = require('../../../../common/maths/geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _elementHelper = require('../../../../common/elements/elementHelper');

var _dndConstants = require('../../../utils/dnd/dndConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Utils


// Helpers


// Constants


/**
 * Need to reposition lines so that the arrow is being held right in the middle.
 */
var getNewLineDragOffset = function getNewLineDragOffset(_ref) {
    var gridSize = _ref.gridSize;
    return pointLib.scale(-1, (0, _dragAndDropUtils.getNewLineDragOrigin)({ gridSize: gridSize }));
};

var getDefaultDragDropPosition = function getDefaultDragDropPosition(_ref2) {
    var gridSize = _ref2.gridSize;
    return pointLib.scale(-gridSize, _dndConstants.DEFAULT_NEW_ELEMENT_DRAG_OFFSET_GRID_UNITS);
};

var isNewLine = function isNewLine(_ref3) {
    var element = _ref3.element;
    return (0, _elementHelper.isLine)(element);
};

/**
 * Retrieves the drag or drop position for an element.
 * Usually this is simply the "source client offset" (the top left point of the element being dragged), however if a
 * board is dragged out of a list it changes shape, so it needs to track the position of the mouse instead (the client
 * offset).
 */
var getNewElementOffset = exports.getNewElementOffset = (0, _lodash.cond)([[isNewLine, getNewLineDragOffset], [_lodash.stubTrue, getDefaultDragDropPosition]]);

exports.default = function (_ref4) {
    var element = _ref4.element,
        gridSize = _ref4.gridSize;
    return _defineProperty({}, element.get('id'), getNewElementOffset({ element: element, gridSize: gridSize }));
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/elementTools/buildNewElementDragOffsetsMap.js
// module id = 2222
// module chunks = 0